import { ContainerModule } from 'inversify';
import AuthService from '../features/auth/data/service/authService';
import AuthRepository from '../features/auth/data/AuthRepository';
import LoginUseCase from '../features/auth/domain/useCases/LoginUseCase';
import SignUpUseCase from '../features/auth/domain/useCases/SignUpUseCase';
import { AuthServiceInterface } from '../features/auth/data/service/authService.types';
import { AuthRepositoryInterface } from '../features/auth/domain/AuthRepositoryInterface';
import {
  GetSocialSignUpProfileUseCaseInterface,
  LoginUseCaseInterface,
  SignUpUseCaseInterface,
} from '../features/auth/domain/useCases/types';
import GetCurrentUserUseCase from 'src/features/auth/domain/useCases/GetCurrentUserUseCase';
import GetSocialSignUpProfileUseCase from 'src/features/auth/domain/useCases/SocialSignUpUseCase';
import { JwtServiceInterface } from 'src/features/auth/data/service/jwtService.types';
import JwtService from 'src/features/auth/data/service/jwtService';

export const authBindings = new ContainerModule((bind) => {
  // Services
  bind<AuthServiceInterface>(AuthService).to(AuthService);
  bind<JwtServiceInterface>(JwtService).to(JwtService);

  // Repositories
  bind<AuthRepositoryInterface>(AuthRepository).to(AuthRepository);

  // Use cases
  bind<LoginUseCaseInterface>(LoginUseCase).to(LoginUseCase);
  bind<SignUpUseCaseInterface>(SignUpUseCase).to(SignUpUseCase);
  bind<GetSocialSignUpProfileUseCaseInterface>(
    GetSocialSignUpProfileUseCase
  ).to(GetSocialSignUpProfileUseCase);
  bind<GetCurrentUserUseCase>(GetCurrentUserUseCase).to(GetCurrentUserUseCase);
});
